// TODO: Create an adaptor for model decorators.